import { AxiosInstance } from 'axios';
import ExistUnprocessedChildOrdersRepository from '@/repository/facility-store/ExistUnprocessedChildOrdersRepository';

export default (axios: AxiosInstance) => {
  const existUnprocessedChildOrdersRepository = ExistUnprocessedChildOrdersRepository(axios);
  return {
    existUnprocessedChildOrdersRepository: existUnprocessedChildOrdersRepository(),
  };
};
